import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import carImg1 from 'images/tmp_fincar_image01.png'
import carImg2 from 'images/tmp_fincar_image02.png'
import carImg3 from 'images/tmp_fincar_image03.png'
import carImg4 from 'images/tmp_fincar_image04.png'

const FincarRecommend = () => {

	const App = useApp()
	const [recommendTab, setRecommendTab] = useState(0)
	const [showFilter, setShowFilter] = useState(false)
	const [toggleFilter, setToggleFilter] = useState(false)

	const openFilter = () => {
		setShowFilter(true)
	}

	const closeFilter = () => {
		setShowFilter(false)
	}

	const toggle = () => {
		setToggleFilter(!toggleFilter)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pt_30 pb_10">
					<h3>핀카 추천</h3>
				</div>
				<div className="no-scroll pb_30" style={{ overflowX: "auto" }}>
					<ul className="tab-round no-wrap">
						<li onClick={() => setRecommendTab(0)} className={recommendTab === 0 ? "active" : ""}>#캠핑</li>
						<li onClick={() => setRecommendTab(1)} className={recommendTab === 1 ? "active" : ""}>#초년생</li>
						<li onClick={() => setRecommendTab(2)} className={recommendTab === 2 ? "active" : ""}>#커플</li>
						<li onClick={() => setRecommendTab(3)} className={recommendTab === 3 ? "active" : ""}>#친환경</li>
						<li onClick={() => setRecommendTab(4)} className={recommendTab === 4 ? "active" : ""}>#NEW</li>
					</ul>
				</div>
			</div>

			<div className="padding py_30">
				<div className="flex-justify_between align_center">
					<div className="flex-align_center">
						<i className={`checkMark`} />
						<span className="ml_10">판매완료 포함</span>
					</div>
					<div className="flex-align_center">
						<div className="filter-group">
							<div onClick={openFilter}>
								<span>등록일 최신순</span>
								<i className="icon icon_filter ml_5" />
							</div>
						</div>

						{/* icon_filter_group 클릭 시 box 클래스 추가 */}
						<i onClick={toggle} className={`icon icon_filter_group ml_10 ${toggleFilter ? "icon_filter_box" : ""}`} />
					</div>
				</div>

				{/* icon_filter_group일 때 type-group 클래스  /  box일 때 type-box 클래스 */}
				<ul className={`${styles["car-list"]} ${styles["type-box"]} mt_50`}>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg1} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like} ${styles.on}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare} ${styles.on}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg2} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>

					<li className={styles["sold-out"]}>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* 판매완료인 경우 sold-out 클래스 추가 img-box 안에 div 추가 */}
								<div className={styles["sold-out-txt"]}><span>판매완료</span></div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
				</ul>
				<Button className="btn btn--big btn-more mt_30">+ 더보기</Button>
			</div>

			<SelectLayer show={showFilter} closeLayer={closeFilter} />
		</div>
	)
}

const SelectLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="정렬필터" show={show} closeLayer={closeLayer}>
			<ul className="select-list">
				<li className="on">등록일 최신 순</li>
				<li>주행거리 적은 순</li>
				<li>연식 최근 순</li>
				<li>가격 낮은 순</li>
				<li>가격 높은 순</li>
			</ul>
		</LayerBottom>
	)
}

export default FincarRecommend